// extracted by mini-css-extract-plugin
export default {"infoText":"ChangeLog_infoText__JV6+R","descriptionText":"ChangeLog_descriptionText__e-iSH"};